import { request } from "@/lib/request";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { memo, useEffect } from "react";
import { toast } from "sonner";
import { captureEvent, sanitizeErrorReason } from "@/lib/analytics";

export const Route = createFileRoute("/verify-email")({
  validateSearch: ({ token }: { token?: string }) => {
    return { token };
  },
  loader: () => {
    return null;
  },
  component: memo(RouteComponent),
});

function RouteComponent() {
  const navigate = useNavigate();
  const { token } = Route.useSearch();

  const checkToken = async () => {
    captureEvent("onboarding_verify_email_started", {
      source: "route",
    });

    if (!token) {
      navigate({
        to: "/",
        search: {
          change_password_token: undefined,
          reset_password_token: undefined,
        },
      });
      return;
    }

    try {
      await request.post(`/auth/verify-email`, { token }).catch(err => {
        throw new Error(
          err.response?.data.message
            ? err.response?.data.message
            : "Something went wrong, please try again.",
        );
      });

      captureEvent("onboarding_verify_email_succeeded", {
        source: "route",
      });
      toast.success("Email verified successfully");
    } catch (err) {
      captureEvent("onboarding_verify_email_failed", {
        source: "route",
        reason: sanitizeErrorReason(err),
      });
      toast.error(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      navigate({
        to: "/",
        search: {
          change_password_token: undefined,
          reset_password_token: undefined,
        },
      });
    }
  };

  useEffect(() => {
    checkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>Checking...</div>;
}
